import { useState } from "react";
import { Modal } from "@iq/models";
import { FiEye } from "react-icons/fi";

function ExpandableNote({ children }) {
    const [isOpen, setIsOpen] = useState(false);
    const text = String(children || "-");
    const canExpand = text.length > 48;

    return (
        <div className="tab-panel-note">
            <span>{text}</span>
            {canExpand ? (
                <button
                    type="button"
                    className="tab-panel-note-toggle"
                    aria-label="View full note"
                    title="View full note"
                    onClick={(event) => {
                        event.stopPropagation();
                        setIsOpen(true);
                    }}
                >
                    <FiEye aria-hidden="true" />
                </button>
            ) : null}
            {isOpen ? (
                <Modal
                    isOpen={true}
                    onClose={() => setIsOpen(false)}
                    title="Full note"
                    icon={<FiEye aria-hidden="true" />}
                    shrink={true}
                >
                    <div className="tab-panel-note-detail">{text}</div>
                </Modal>
            ) : null}
        </div>
    );
}

export default ExpandableNote;
